<div
  appDroppable
  [appDroppableDisabled]="busy() || dragBusy()"
  [appDroppablePredicate]="accepts"
  (appDroppableEnter)="dragOver.set(true)"
  (appDroppableLeave)="dragOver.set(false)"
  (appDroppableDrop)="drop($event)"
>
  <app-quick-action-button
    label="New board"
    hint="Drag to create"
    dropLabel="Drop to create"
    [dragOver]="dragOver()"
    ariaLabel="New board"
    stchPopover
    stchPopoverTrigger="click"
    stchPopoverPlacement="bottomLeft"
    [stchPopoverContent]="menu"
    [stchPopoverShowUntil]="menuChosen"
  />
</div>
@if (busy() || dragBusy()) {
  <p role="status">Creating board…</p>
}
@if (notice()) {
  <p role="status">{{ notice() }}</p>
}
@if (canRetry()) {
  <app-button2 [disabled]="dragBusy()" (click)="retryDrag()">Retry</app-button2>
  @if (canKeep()) {
    <app-button2 appearance="secondary-text" [disabled]="dragBusy()" (click)="keepDrag()">Keep without link</app-button2>
  }
  <app-button2 appearance="secondary-text" [disabled]="dragBusy()" (click)="cancelDrag()">Cancel remaining items</app-button2>
}
@if (error()) {
  <p role="alert" class="text-sm text-error">{{ error() }}</p>
}
@if (aiForm()) {
  <label class="flex flex-col gap-2 py-2"
    >What should the board cover?
    <textarea class="rounded border border-border p-2" [formControl]="prompt" rows="3"></textarea>
  </label>
  <app-button2 [disabled]="busy() || !prompt.value.trim()" (click)="blank(true)">Create with Stitchy</app-button2>
}
<ng-template #menu
  ><app-context-menu-window>
    <app-context-menu-item title="Blank board" [disabled]="busy()" (execute)="menuChosen.next(); blank()" />
    <app-context-menu-item title="From a template" [disabled]="busy()" (execute)="menuChosen.next(); choose('template')" />
    <app-context-menu-item title="Import board" [disabled]="busy()" (execute)="menuChosen.next(); choose('import')" />
    <app-context-menu-item
      title="Create with Stitchy"
      [disabled]="busy() || !stitchyCreate"
      [note]="stitchyCreate ? undefined : stitchyUnavailable"
      [trailingNote]="stitchyCreate ? undefined : 'Not connected'"
      (execute)="menuChosen.next(); aiForm.set(true)"
    />
  </app-context-menu-window
></ng-template>
